export default __webpack_public_path__ + "static/media/logo-regenesis.cd1e6ed5.svg";